export async function regenCompareQuery({ client, fileId }) {
  const { data } = await client.get(`figma/files/${fileId}/regen_compare/`);
  return data;
}
